// Visitor runtime config (F-B / ADR-0022). Fetched once per session,
// kept fresh forever (staleTime: Infinity) — the config rarely changes
// and a stale value is harmless (the validation bounds widen, never
// narrow, on a CODE_DIGITS bump).

import { useQuery } from "@tanstack/react-query";
import { PublicConfig, getPublicConfig } from "../config";

export const configKey = ["public-config"] as const;

// Sensible fallback if the request fails — keeps CodeEntry working with
// the legacy 3-digit assumption. ADR-0022 §"Consequences" allows this:
// frontend can ship before backend; old codes stay valid through the bump.
export const CONFIG_FALLBACK: PublicConfig = {
  codeDigits: 3,
  codeMinDigits: 3,
  codeMaxDigits: 8,
  batchUploadMaxBytes: 100 * 1024 * 1024,
};

export function useConfig() {
  return useQuery<PublicConfig>({
    queryKey: configKey,
    queryFn: getPublicConfig,
    staleTime: Infinity,
    placeholderData: CONFIG_FALLBACK,
  });
}
